module.exports = __webpack_public_path__ + "img/good-vertical-stairs.1b3ae36f.gif";